// extracted by mini-css-extract-plugin
module.exports = {"content":"side-bar_content__xwHjq","list":"side-bar_list__1YL6Y"};